export { default } from './404.js'
